import React, { useState, useEffect, useMemo } from "react";
import "./copy-auction.styles.scss";
import CustomSelect from "../../components/custom-select/custom-select.component";
import { ReactComponent as CheckedIcon } from "../../assets/checked.svg";
import { ReactComponent as CloseIcon } from "../../assets/cancel.svg";

import IndividualItem from "../../components/slot-individual-item/slot-individual-item.component";

import {
  CopyOutlined,
  ExclamationCircleOutlined,
  LeftOutlined,
  PlusOutlined,
} from "@ant-design/icons";

import dayjs from "dayjs";

import {
  setBypassBD,
  setCurrentPage,
  setSelectedBranch,
  setSelectedCrop,
  setVarieties,
} from "../../redux/common/common.actions";

import { connect, useDispatch } from "react-redux";
import { createStructuredSelector } from "reselect";

import {
  selectVarieties,
  selectBranches,
  selectCrops,
  selectSelectedCrop,
  selectTC,
  selectCurrentPage,
  selectSelectedBranch,
  selectMinQty,
  selectSaudhaType,
  selectRebates,
  selectBypassBD,
  selectBagtypeList,
  selectDefaultParams,
  selectViewAuctionPage,
} from "../../redux/common/common.selectors";
// import { setBranchIndex } from "../../redux/common/common.actions";
import { Dispatch } from "redux";
import {
  getBuyingDecision,
  getCopyAuctionsData,
  postAuction,
  getSlotAuctions,
  getMaterialCodes,
} from "../../services/auction-services";
// import { getSysParams } from "../../services/sys-params-services";
import {
  getAuctionType,
  getRebateService,
} from "../../services/common-services";

import {
  Table,
  Input,
  Radio,
  DatePicker,
  Button,
  message,
  Modal,
  Checkbox,
  Flex,
  Space,
  Breadcrumb,
  Typography,
  Form,
  InputNumber,
  Select,
  Switch,
} from "antd";
import { selectUserData } from "../../redux/user/user.selectors";
import { canUserAccess } from "../../utils/utils";
import { FeatureCodes } from "../../constants/data-constants";
import { useLocation } from "react-router";
const { TextArea } = Input;
const { confirm } = Modal;

interface ITableData {
  key: number | undefined;
  hub: string | undefined;
  division: number | undefined;
  claim: number | undefined;
  quantity: number | undefined;
  min: number | undefined;
  max: number | undefined;
}

interface ISlotsGet {
  slot_id: number;
  qty_rqd: number | null;
  qty_fulfilled: number | null;
  rebate_id: string | null;
}

interface IFormData {
  crop_id: number | null;
  branch_id: number | null;
  variety_id: number | null;
  hub_id: number | null;
  hub_name: string | null;
  division: number | null;
  saudaType: number | null;
  saudha_type: number | null;
  claim_type: number | null;
  role_type: number | null;
  max_price: number | null;
  min_price: number | null;
  need_date: string | null;
  slots: Array<any> | null;
  remarks: string | null;
  bag_type: number | null;
  del_loc_sap_code: string | null;
  buying_decision_id: number | null;
  total_qty: number;
  normal_auction_exists: boolean | null;
  withBd: boolean | null;
}

const CopyAuction: React.FC = (props: any) => {
  const {
    varieties,
    branches,
    selectedCrop,
    crops,
    currentPage,
    selectedBranch,
    minQty,
    saudhaType,
    rebates,
    setSelectedBranchIndex,
    setSelectedCropsIndex,
    selectDefaultParams,
    bypassEnabled,
    bagTypeList,
    viewAuctionPage,
    userData,
  } = props;
  const formDefault = {
    crop_id: null,
    branch_id: null,
    variety_id: null, // varieties[0]?.id,
    hub_id: null,
    division: null,
    del_loc_sap_code: null,
    bag_type: null,
    saudha_type: null,
    role_type: null,
    claim_type: null,
    max_price: null,
    min_price: null,
    need_date: null,
    slots: null,
    remarks: "",
    buying_decision_id: null,
    normal_auction_exists: null,
    hub_name: "",
    needDate: null,
    saudaType: null,
    roleType: null,
    varietyName: null,
    total_qty: 0,
    withBd: null,
  };
  const dispatch = useDispatch();
  const [tableData, setTableData] = useState<Array<ITableData>>([]);
  const [editable, setEditable] = useState(true);
  const [formData, setFormData] = useState<IFormData>(formDefault);
  const [modalVisible, setModalVisible] = useState(false);
  const [bdLoading, setBdLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [rebateList, setRebateList] = useState<any>([]);
  const [materialList, setMaterialList] = useState<any>([]);
  const [auctionTypes, setAuctionType] = useState<any>([]);
  const [searchText, setSearchText] = useState("");
  const location = useLocation();

  const [form] = Form.useForm();

  const columnsCopy = [
    {
      title: "Slot",
      dataIndex: "slot_id",
      key: "slot_id",
      render: (_, __) => {
        return (
          <Space direction="vertical">
            <Typography.Text style={{ fontSize: 14 }}>
              Slot {__.slot_number}
            </Typography.Text>
            <Typography.Text style={{ fontSize: 10 }}>
              {dayjs(__?.start_time, "HH:mm:ss").format("hh:mm A")} -{" "}
              {dayjs(__?.end_time, "HH:mm:ss").format("hh:mm A")}
            </Typography.Text>
          </Space>
        );
      },
    },
    {
      title: "Rake Auction",
      dataIndex: "auction_type",
      key: "auction_type",
      width: 90,
      render: (_, __) => {
        return (
          // <Switch
          //   onChange={(value: any) =>
          //     onSlotValueChanged(value, __.slot_id, "auction_type")
          //   }
          //   checkedChildren="Yes"
          //   unCheckedChildren="No"
          //   value={_}
          // />
          <Form.Item
            name={["rows", __.slot_id, "auction_type"]}
            style={{ margin: 0 }}
          >
            <Select
              onChange={(value: any) =>
                onSlotValueChanged(value, __.slot_id, "auction_type")
              }
              disabled={
                dayjs(__.start_time, "HH:mm:ss").isBefore(dayjs()) ||
                (__.auction_freeze_period &&
                  dayjs(
                    dayjs("HH:mm:ss").add(__.auction_freeze_period, "minutes"),
                    "HH:mm:ss"
                  ).isAfter(dayjs(__.start_time, "HH:mm:ss")))
              }
              options={auctionTypes}
              // options={[
              //   { value: 1, label: "Normal" },
              //   { value: 2, label: "Rake" },
              //   { value: 3, label: "Container Rake Bid" },
              // ]}
            />
          </Form.Item>
        );
      },
    },
    {
      title: `Slot Quantity (${
        crops?.find((item) => item.id == selectedCrop)?.unit
      })`,
      dataIndex: "qty_rqd",
      key: "qty_rqd",
      width: 180,
      render: (_, record: any) => (
        <>
          <Form.Item
            name={["rows", record.slot_id, "qty_rqd"]}
            // rules={[{ required: true, message: "Please enter Slot Quantity" }]}
            style={{ margin: 0 }}
          >
            {record.auction_type == 3 ? (
              <Select
                onChange={(value: any) =>
                  onSlotValueChanged(value, record.slot_id, "qty_rqd")
                }
                disabled={
                  record.qty_fulfilled !== null ||
                  dayjs(record.start_time, "HH:mm:ss").isBefore(dayjs()) ||
                  (record.auction_freeze_period &&
                    dayjs(
                      dayjs("HH:mm:ss").add(
                        record.auction_freeze_period,
                        "minutes"
                      ),
                      "HH:mm:ss"
                    ).isAfter(dayjs(record.start_time, "HH:mm:ss")))
                }
                options={[
                  {
                    value: Number(
                      selectDefaultParams?.rj_container_bid_full_rake
                    ),
                    label: selectDefaultParams?.rj_container_bid_full_rake,
                  },
                  {
                    value: Number(
                      selectDefaultParams?.rj_container_bid_half_rake
                    ),
                    label: selectDefaultParams?.rj_container_bid_half_rake,
                  },
                ]}
              />
            ) : (
              <InputNumber
                min={0}
                // style={{ width: "50%" }}
                onChange={(value: any) =>
                  onSlotValueChanged(value, record.slot_id, "qty_rqd")
                }
                onBlur={(e: any) => {
                  const rows = form.getFieldValue("rows");
                  if (
                    record.auction_type == 2 &&
                    !/^\d+(\.5)?$/.test(
                      `${e.target.value / selectDefaultParams.full_rake}`
                    )
                  ) {
                    message.warning("Enter Valid Quantity...!");
                    rows[record.slot_id].qty_rqd = 0; // clear value
                    form.setFieldsValue({ rows });
                    onSlotValueChanged(0, record.slot_id, "qty_rqd");
                  }
                }}
                disabled={
                  record.qty_fulfilled !== null ||
                  dayjs(record.start_time, "HH:mm:ss").isBefore(dayjs()) ||
                  (record.auction_freeze_period &&
                    dayjs(
                      dayjs("HH:mm:ss").add(
                        record.auction_freeze_period,
                        "minutes"
                      ),
                      "HH:mm:ss"
                    ).isAfter(dayjs(record.start_time, "HH:mm:ss")))
                }
              />
            )}
          </Form.Item>
          {record.auction_type == 2 && (
            <Typography.Text style={{ fontSize: 10 }}>
              Rake Count:{" "}
              {/^\d+(\.5)?$/.test(`${_ / selectDefaultParams.full_rake}`)
                ? _ / selectDefaultParams.full_rake
                : 0}
            </Typography.Text>
          )}
        </>
      ),
    },
    {
      title: "Rebate Name",
      dataIndex: "rebate_id",
      key: "rebate_id",
      render: (_, __) => (
        <Form.Item
          name={["rows", __.slot_id, "rebate_id"]}
          // rules={[{ required: true, message: "Please enter Rebate Name" }]}
          style={{ margin: 0 }}
        >
          <Select
            onChange={(value: any) =>
              onSlotValueChanged(value, __.slot_id, "rebate_id")
            }
            disabled={
              __.qty_fulfilled !== null ||
              dayjs(__.start_time, "HH:mm:ss").isBefore(dayjs()) ||
              (__.auction_freeze_period &&
                dayjs(
                  dayjs("HH:mm:ss").add(__.auction_freeze_period, "minutes"),
                  "HH:mm:ss"
                ).isAfter(dayjs(__.start_time, "HH:mm:ss"))) ||
              formData.claim_type === 2
            }
            options={rebateList.map((item: any) => ({
              value: item.rebate_id,
              label: item.rebate_name,
            }))}
          >
            {/* {rebateList.map((item: any) => (
              <Option
                value={item.rebate_id}
                id={item.rebate_id}
                key={item.rebate_id}
              >
                {item.rebate_name}
              </Option>
            ))} */}
          </Select>
        </Form.Item>
      ),
    },
    {
      title: `Max Price (₹/${
        crops?.find((item) => item.id == selectedCrop)?.unit
      })`,
      dataIndex: "max_price",
      key: "max_price",
      width: 150,
      render: (_, __) => (
        <Form.Item
          name={["rows", __.slot_id, "max_price"]}
          // rules={[{ required: true, message: "Please enter Max Price" }]}
          style={{ margin: 0 }}
        >
          <InputNumber
            min={0}
            style={{ width: "100%" }}
            onChange={(value: any) =>
              onSlotValueChanged(value, __.slot_id, "max_price")
            }
            disabled={
              __.qty_fulfilled !== null ||
              dayjs(__.start_time, "HH:mm:ss").isBefore(dayjs()) ||
              (__.auction_freeze_period &&
                dayjs(
                  dayjs("HH:mm:ss").add(__.auction_freeze_period, "minutes"),
                  "HH:mm:ss"
                ).isAfter(dayjs(__.start_time, "HH:mm:ss")))
            }
          />
        </Form.Item>
      ),
    },
    {
      title: "Need Date",
      dataIndex: "need_date",
      key: "need_date",
      render: (_, record) => (
        <Form.Item
          name={["rows", record.slot_id, "need_date"]}
          style={{ margin: 0 }}
        >
          <DatePicker
            value={[dayjs(record.need_date).format("YYYY-MM-DD")]}
            style={{ width: "100%" }}
            onChange={(value: any) =>
              onSlotValueChanged(value, record.slot_id, "need_date")
            }
            format={"YYYY-MM-DD"}
            disabledDate={(d) => d.isBefore(dayjs())}
            disabled={
              record.qty_fulfilled !== null ||
              dayjs(record.start_time, "HH:mm:ss").isBefore(dayjs()) ||
              (record.auction_freeze_period &&
                dayjs(
                  dayjs("HH:mm:ss").add(
                    record.auction_freeze_period,
                    "minutes"
                  ),
                  "HH:mm:ss"
                ).isAfter(dayjs(record.start_time, "HH:mm:ss")))
            }
          />
        </Form.Item>
      ),
    },
    {
      title: "Material Code",
      dataIndex: "material_code",
      key: "material_code",
      render: (_, __) => (
        <Form.Item
          name={["rows", __.slot_id, "material_code"]}
          // rules={[{ required: true, message: "Please enter Material Code" }]}
          style={{ margin: 0 }}
        >
          <Select
            onChange={(value: any) =>
              onSlotValueChanged(value, __.slot_id, "material_code")
            }
            disabled={
              __.qty_fulfilled !== null ||
              dayjs(__.start_time, "HH:mm:ss").isBefore(dayjs()) ||
              (__.auction_freeze_period &&
                dayjs(
                  dayjs("HH:mm:ss").add(__.auction_freeze_period, "minutes"),
                  "HH:mm:ss"
                ).isAfter(dayjs(__.start_time, "HH:mm:ss")))
            }
            options={materialList.map((item: any) => ({
              value: item.value,
              label: item.value,
            }))}
          >
            {/* {materialList &&
              materialList.map((item: any) => (
                <Option value={item.value} id={item.id} key={item.id}>
                  {item.value}
                </Option>
              ))} */}
          </Select>
        </Form.Item>
      ),
    },
    {
      title: "Bag Type",
      dataIndex: "bag_type",
      key: "bag_type",
      render: (_, __) => (
        <Form.Item
          name={["rows", __.slot_id, "bag_type"]}
          // rules={[{ required: true, message: "Please enter Bag Type" }]}
          style={{ margin: 0 }}
        >
          <Select
            onChange={(value: any) =>
              onSlotValueChanged(value, __.slot_id, "bag_type")
            }
            disabled={
              __.qty_fulfilled !== null ||
              dayjs(__.start_time, "HH:mm:ss").isBefore(dayjs()) ||
              (__.auction_freeze_period &&
                dayjs(
                  dayjs("HH:mm:ss").add(__.auction_freeze_period, "minutes"),
                  "HH:mm:ss"
                ).isAfter(dayjs(__.start_time, "HH:mm:ss")))
            }
            options={bagTypeList.map((item: any) => ({
              value: item.id,
              label: item.name,
            }))}
          >
            {/* {bagTypeList &&
              bagTypeList.map((item: any) => (
                <Option value={item.id} id={item.id} key={item.name}>
                  {item.name}
                </Option>
              ))} */}
          </Select>
        </Form.Item>
      ),
    },
  ];
  const columns = [
    {
      title: "Hub",
      dataIndex: "hub_name",
      key: "hub_name",
      sorter: (a, b) => a.hub_name.length - b.hub_name.length,
    },
    {
      title: "Claim Type",
      dataIndex: "claim_type",
      key: "claim_type",
      render: (value: number) => {
        return (
          <div className="claim-container">
            {value === 1 ? <CheckedIcon /> : <CloseIcon />}
          </div>
        );
      },
    },
    {
      title: "Division ",
      dataIndex: "division",
      key: "division",
      render: (value: number) => {
        return <div>{value === 1 ? "ABD" : value === 2 ? "FBD" : "NCDEX"}</div>;
      },
      sorter: (a, b) => a.division.length - b.division.length,
    },
    {
      title: "Sauda Type",
      dataIndex: "saudha_type",
      key: "saudha_type",
      render: (value: number) => {
        return (
          // <div className="claim-container">
          value === 1 ? "Net Basis" : "Gross Basis"
          // </div>
        );
      },
    },
    {
      title: "Rake Sauda",
      dataIndex: "auction_type",
      key: "auction_type",
      render: (value: any) => {
        return value == 2 || value == 3 ? "Y" : "N";
      },
    },
    {
      title: "Role",
      dataIndex: "role_mapping",
      key: "role_mapping",
      render: (value: number) => {
        return value === 1
          ? "Broker/Trader"
          : value === 2
          ? "FPO"
          : value === 3
          ? "Broker/Trader & FPO"
          : "Not Selected";
      },
    },
    {
      title: `Auction Qty (${
        crops?.find((item) => item.id == selectedCrop)?.unit
      })`,
      dataIndex: "qty_rqd",
      key: "qty_rqd",
      sorter: (a, b) => a.qty_rqd - b.qty_rqd,
    },
    {
      title: `Min Price (₹/${
        crops?.find((item) => item.id == selectedCrop)?.unit
      })`,
      dataIndex: "min_price",
      key: "min_price",
    },
    {
      title: `Max Price (₹/${
        crops?.find((item) => item.id == selectedCrop)?.unit
      })`,
      dataIndex: "max_price",
      key: "max_price",
    },
    {
      title: "Auction Date",
      dataIndex: "auction_date",
      key: "auction_date",
    },
    {
      title: "Action",
      dataIndex: "create",
      key: "create",
      render: (value: any, rowData: any) => {
        return (
          <Button
            // className="create-auction-link"
            icon={<CopyOutlined />}
            style={{
              color: "#123274",
              borderColor: "#123274",
            }}
            disabled={canUserAccess(
              userData,
              FeatureCodes.AUDITOR_VIEW_ONLY_ACCESS
            )}
            onClick={() => {
              const params = {
                crop_id: formData.crop_id,
                branch_id: formData.branch_id,
                hub_id: rowData.hub_id,
                variety_id: formData.variety_id,
                claim_type: rowData.claim_type,
                division: rowData.division,
                // hub_name: rowData.hub_name,
              };
              setFormData((prevFormData) => ({
                ...prevFormData,
                division: rowData.division,
                hub_id: rowData.hub_id,
                hub_name: rowData.hub_name,
                claim_type: rowData.claim_type,
                max_price: rowData.max_price,
                min_price: rowData.min_price,
                buying_decision_id: rowData.key,
                total_qty: rowData.qty_rqd,
                needDate: rowData.AuctionDate,
                saudaType: rowData.saudha_type,
                role_type: rowData.role_mapping,
                varietyName: rowData.variety_name,
                slots: [],
                allSlots: rowData.all_slots,
              }));
              const rebateParams = {
                crop_id: formData.crop_id,
                branch_id: formData.branch_id,
                variety_id: formData.variety_id,
                division: rowData.division_name,
              };
              getVarietyData(rebateParams);
              getMaterialData({
                variety_id: formData.variety_id,
                auction_division: rowData.division_name,
              });
              getSlotAuctionDetails(params, rowData);
            }}
          >
            Copy Auction
          </Button>
        );
      },
    },
  ];
  const filteredData = useMemo(() => {
    if (!searchText) return tableData;

    return tableData.filter((row) =>
      Object.values(row).some((value) =>
        String(value).toLowerCase().includes(searchText.toLowerCase())
      )
    );
  }, [tableData, searchText]);

  useEffect(() => {
    // if (currentPage == 3 && viewAuctionPage == "35" && !bypassEnabled) {
    if (location.pathname.includes("/viewauction/create") && !bypassEnabled) {
      setFormData({
        ...formDefault,
        crop_id: selectedCrop,
        branch_id: selectedBranch,
        saudha_type: +saudhaType,
        variety_id: varieties[0]?.id,
      });
      if (selectedBranch && varieties[0]?.id && selectedCrop)
        getAuction(selectedBranch, varieties[0]?.id, selectedCrop);
      if (selectedCrop && selectedBranch) {
        getAuctionData({
          crop_id: selectedCrop,
          branch_id: selectedBranch,
        });
      }
    }
  }, [currentPage, selectedCrop, viewAuctionPage, selectedBranch, varieties]);

  const getVarietyData = async (params: any) => {
    try {
      const rebateListResponse = await getRebateService(params);
      if (rebateListResponse.data.status) {
        setRebateList(rebateListResponse.data.data);
      }
    } catch (error) {
      console.warn("error", error);
    }
  };
  const getAuctionData = async (params: any) => {
    try {
      const auctionTypeResponse = await getAuctionType(params);
      if (auctionTypeResponse.data.status) {
        setAuctionType(
          auctionTypeResponse.data.data.map((item: any) => {
            return {
              value: item.auction_type_id,
              label: item.auction_type_name,
            };
          })
        );
      }
    } catch (error) {
      console.warn("error", error);
    }
  };
  const getSlotAuctionDetails = async (params: any, rowData: any) => {
    try {
      const response = await getSlotAuctions(params);
      if (response.data.status) {
        var newSlots: any = [];
        response.data.data.slots.forEach((slot, index) => {
          newSlots.push({
            ...slot,
            // auction_type: slot.auction_type == 1 ? false : true,
            need_date: dayjs().add(7, "days").format("YYYY-MM-DD"),
          });
        });
        form.resetFields();
        setFormData((prevFormData) => ({
          ...prevFormData,
          slots: newSlots,
          // slots: response.data.data.slots,   // directly assigining the new slots
          // max_price: response.data.data.max_price,
          need_date: response.data.data.need_date,
          remarks: response.data.data.remarks,
          normal_auction_exists: response.data.data.normal_auction_exists,
        }));
        var edit = true;
        response.data.data.slots.map((item: any) => {
          if (dayjs(item.start_time, "HH:mm:ss").isSameOrBefore(dayjs())) {
            edit = false;
          }
        });
        const slotData = response.data.data.slots;
        const objectSlots = Object.fromEntries(
          slotData.map((item) => [
            item.slot_id,
            {
              ...item,
              need_date: dayjs().add(7, "days"),
            },
          ])
        );
        form.setFieldsValue({
          rows: objectSlots,
        });
        if (response.data.data.max_price !== null && !edit) setEditable(false);
        else setEditable(true);
        setModalVisible(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getMaterialData = async (params: any) => {
    try {
      const response = await getMaterialCodes(params);
      if (response.data.status) {
        const data = response.data.data.map((item: any) => {
          return {
            id: item.pk_id,
            value: item.material_code,
          };
        });
        setMaterialList(data);
      }
    } catch (error) {
      console.warn("error", error);
    }
  };
  const getAuction = async (
    branchId = formData.branch_id,
    varietyId = formData.variety_id,
    cropId = formData.crop_id
  ) => {
    try {
      setBdLoading(true);
      const params = {
        branch_id: branchId,
        variety_id: varietyId,
        crop_id: cropId,
      };
      const response = await getCopyAuctionsData(params);
      if (response.data.status && response.data?.data?.length) {
        const data = response.data.data.map((item: any, index: any) => {
          return {
            ...item,
            key: index,
            // hub: item.hub_name,
            // division: item.division,
            // claim: item.claim_type,
            // quantity: item.qty,
            // min: item.min_price,
            // max: item.max_price,
            // hubId: item.hub_id,
            // all_slots: item.all_slots
          };
        });
        setTableData(data);
      } else {
        message.info(response.data.message, 1);
        setTableData(response.data.data);
      }
      setBdLoading(false);
    } catch (error: any) {
      setBdLoading(false);
      // message.error(
      //   error.response.data?.message ||
      //     "Something went wrong , please try again later."
      // );
    }
  };

  function showPromiseConfirm() {
    confirm({
      title: "Override auction ?",
      icon: <ExclamationCircleOutlined />,
      content:
        "An auction exist for this combination, Are you sure you want to override ?",
      okText: "Yes",
      cancelText: "No",
      onOk() {
        createAuction();
      },
      onCancel() {
        setFormData({
          ...formDefault,
          crop_id: selectedCrop,
          branch_id: selectedBranch,
          saudha_type: +saudhaType,
          variety_id: varieties[0]?.id,
        });
        setModalVisible(false);
      },
    });
  }

  const createAuctionClicked = () => {
    setIsLoading(true);
    if (formData.normal_auction_exists) {
      showPromiseConfirm();
    } else createAuction();
    setIsLoading(false);
  };

  const createAuction = async () => {
    const postData: any = [];
    if (formData.slots?.length === 0) {
      message.warning("Can not find any slots.");
      return false;
    } else if (formData.slots && formData.slots?.length !== 0) {
      let isFieldDataEmpty: boolean = true;
      for (let i = 0; i < formData.slots?.length; i++) {
        if (!formData.slots[i].is_edit) {
          continue;
        }
        if (
          formData.slots[i].is_active &&
          formData.slots[i].need_date &&
          (formData.slots[i].qty_rqd || formData.slots[i].max_price)
        ) {
          const maxPrice = varieties.filter(
            (item: any) => item.id === formData.variety_id
          )[0].maxPrice;
          const minPrice = varieties.filter(
            (item: any) => item.id === formData.variety_id
          )[0].minPrice;
          if (
            dayjs(
              dayjs(dayjs(), "HH:mm:ss").add(
                formData.slots[i].auction_freeze_period,
                "minutes"
              ),
              "HH:mm:ss"
            ).isAfter(dayjs(formData.slots[i].start_time, "HH:mm:ss"))
          ) {
            message.warning(
              `Auction cannot be created ${formData.slots[i].auction_freeze_period} minute(s) before the slot start time.`
            );
            return false;
          } else if (
            formData.claim_type === 1 &&
            formData.slots[i].rebate_id === null
          ) {
            message.warning("Please enter valid rebate id.");
            return false;
          } else if (
            formData.slots[i].qty_rqd === null ||
            isNaN(formData.slots[i].qty_rqd)
          ) {
            message.warning("Please enter valid Slot qty.");
            return false;
          } else if (
            formData.slots[i].max_price === null ||
            isNaN(formData.slots[i].max_price)
          ) {
            message.warning("Please enter max price...");
            return false;
          } else if (
            formData.slots[i].max_price <= minPrice ||
            formData.slots[i].max_price >= maxPrice
          ) {
            message.warning(
              `Max price should be between the range ${minPrice} (₹/${
                crops?.find((item) => item.id == selectedCrop)?.unit
              }) to ${maxPrice} (₹/${
                crops?.find((item) => item.id == selectedCrop)?.unit
              })...`
            );
            return false;
          } else if (
            isNaN(formData.slots[i].max_price) ||
            formData.slots[i].max_price <= 0
          ) {
            message.warning("Enter a valid max price...");
            return false;
          } else if (
            formData.slots[i].need_date === "" ||
            formData.slots[i].need_date === null ||
            formData.slots[i].need_date === undefined
          ) {
            message.warning("Please enter need date...");
            return false;
          } else if (
            formData.slots[i].material_code === "" ||
            formData.slots[i].material_code === null ||
            formData.slots[i].material_code === undefined
          ) {
            message.warning("Please select Material...");
            return false;
          } else if (
            formData.slots[i].bag_type === "" ||
            formData.slots[i].bag_type === null ||
            formData.slots[i].bag_type === undefined
          ) {
            message.warning("Please select Bag type...");
            return false;
          }
          // formData.slots[i].auction_type = formData.slots[i].auction_type
          //   ? 2
          //   : 1;
          postData.push({
            ...formData.slots[i],
            id: i,
            end_time: formData.slots[i].bid_ends_on,
            rebate_matrix_id: formData.slots[i].rebate_id,
          });
          postData
            .filter((item: any) => item.id === i)
            .map((item: any) => {
              item.qty_fulfilled =
                item.qty_fulfilled === null ? 0 : item.qty_fulfilled;
              delete item.bid_ends_on;
              delete item.rebate_id;
              delete item.auction_freeze_period;
              delete item.slot_number;
              delete item.start_time;
              delete item.showError;
              delete item.id;
              delete item.is_edit;
            });
          isFieldDataEmpty = false;
        } else if (
          formData.slots[i].qty_rqd === null &&
          formData.slots[i].max_price === null &&
          formData.slots[i].need_date ===
            dayjs().add(7, "days").format("YYYY-MM-DD")
        ) {
          continue;
        } else {
          if (formData.slots[i].is_active) {
            message.warning("Please enter valid slot details...");
            return false;
          }
          continue;
        }
      }
      if (!isFieldDataEmpty) {
        setFormData((prev: IFormData) => {
          const modifiedData: any = {
            ...prev,
            saudha_type: prev.saudaType,
            slots: postData,
            role_type: [15],
            withBd: false,
            min_price: null,
            buying_decision_id: null,
          };
          delete modifiedData.allSlots;
          delete modifiedData.need_date;
          delete modifiedData.normal_auction_exists;
          delete modifiedData.roleType;
          delete modifiedData.saudaType;
          delete modifiedData.total_qty;
          delete modifiedData.varietyName;
          delete modifiedData.hub_name;
          delete modifiedData.max_price;
          (async (modifiedData) => {
            try {
              const postResponse = await postAuction(modifiedData);
              if (postResponse.data.status) {
                message.success("Auction created / updated successfully");
                setModalVisible(false);
              } else {
                message.error(
                  postResponse.data.message || "Something went wrong :("
                );
              }
            } catch (err: any) {
              message.error(
                err.response.data.message || "Something went wrong :("
              );
            }
          })(modifiedData);
          return prev;
        });
        return true;
      } else {
        message.error("Please fill slot datas to create/update auctions.");
        return false;
      }
    }
  };

  const onSlotValueChanged = async (
    value: number,
    slotId: number,
    changedField: string | any
  ) => {
    let slotChangedData = formData.slots;
    slotChangedData !== null &&
      slotChangedData.map((item: any) => {
        if (item.slot_id === slotId) {
          if (changedField == "need_date")
            item[changedField] = value
              ? dayjs(value).format("YYYY-MM-DD")
              : null;
          else item[changedField] = value ? value : null;
          item["is_edit"] = true;
          if (
            changedField !== "rebate_id" &&
            changedField !== "max_price" &&
            changedField !== "bag_type" &&
            changedField !== "material_code" &&
            changedField !== "auction_type" &&
            changedField !== "need_date"
          ) {
            if (value < minQty) {
              item["showError"] = true;
            } else {
              item["showError"] = false;
            }
          }
        }
        return item;
      });
    setFormData({ ...formData, slots: slotChangedData });
  };

  return (
    <div className="copy-auction-bd">
      {modalVisible ? (
        <Space
          direction="vertical"
          style={{ textAlign: "left", width: "100%" }}
        >
          <Breadcrumb
            items={[
              {
                title: (
                  <>
                    <LeftOutlined />
                    <span>Create Auction</span>
                  </>
                ),
                onClick: () => setModalVisible(false),
              },
              {
                title: "Copy Auction",
              },
            ]}
          />
          <Space>
            <Typography.Text type="danger">
              <b>NOTE:</b> Auction cannot be created 5 minute(s) before the slot
              start time
            </Typography.Text>
          </Space>
          <Typography.Title
            level={5}
            style={{ textAlign: "start", marginBlock: 10 }}
          >
            Select Sauda Type
          </Typography.Title>
          <Flex gap={"small"}>
            <div className="label">
              <label style={{ color: "red" }}>*</label> Sauda Type
            </div>
            <Radio.Group
              value={formData.saudaType}
              onChange={(e) =>
                setFormData({ ...formData, saudaType: e.target.value })
              }
              disabled={!editable}
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 8,
              }}
            >
              <Radio value={1}>Net basis</Radio>
              <Radio value={2}>Gross basis</Radio>
            </Radio.Group>
          </Flex>
          {/* <div className="right-container">
            <div className="slots-container">
              {formData.slots !== undefined &&
                formData.slots
                  ?.filter(
                    (item: any) => item.is_active && item.is_active === true
                  )
                  .map((item: any, index: number) => {
                    return (
                      <IndividualItem
                        key={index}
                        index={index}
                        cropId={formData?.crop_id || crops[0].id}
                        slotId={item.slot_id}
                        branchId={formData?.branch_id || branches[0].id}
                        slotNumber={item.slot_number}
                        onChangeFn={onSlotValueChanged}
                        minQtyShow={
                          item.showError == undefined ? false : item.showError
                        }
                        sysParametersData={minQty}
                        requiredQty={item.qty_rqd}
                        purchasedQty={item.qty_fulfilled}
                        rebateId={item.rebate_id}
                        auctionFreezePeriod={item.auction_freeze_period}
                        startTime={item.start_time}
                        endTime={item.end_time}
                        rebateList={rebateList}
                        bag_type={item?.bag_type}
                        bagTypeList={bagTypeList}
                        materialList={materialList}
                        material_code={item.material_code}
                        claim={formData.claim_type}
                        needDate={item.need_date}
                        maxPrice={item.max_price}
                      />
                    );
                  })}
            </div>
          </div> */}
          <Flex vertical>
            <Form
              form={form}
              initialValues={{
                rows:
                  formData.slots &&
                  formData.slots
                    .filter(
                      (item: any) => item.is_active && item.is_active === true
                    )
                    .map((row) => ({
                      ...row,
                      need_date: row.need_date && dayjs(row.need_date),
                    })),
              }}
            >
              <Table
                rowKey="slot_id"
                columns={columnsCopy}
                size="small"
                dataSource={
                  formData.slots
                    ? formData.slots.filter(
                        (item: any) => item.is_active && item.is_active === true
                      )
                    : []
                }
                scroll={{ x: "max-content" }}
              />
            </Form>
          </Flex>
          <Flex justify="flex-start" gap={10} style={{ paddingTop: 10 }}>
            <div className="label">Remarks : {"   "}</div>
            <TextArea
              value={formData.remarks === null ? undefined : formData.remarks}
              showCount
              autoSize={{ minRows: 2, maxRows: 6 }}
              maxLength={30}
              onChange={(e) => {
                const text = e.target.value.replace(/[^a-zA-Z0-9\s,._-]/g, "");
                setFormData({
                  ...formData,
                  remarks: text,
                });
              }}
              disabled={!editable}
              style={{ width: "80vh" }}
            />
          </Flex>
          <div className="bottom-container">
            <Button
              loading={isLoading}
              type="primary"
              onClick={createAuctionClicked}
            >
              Create Auction
            </Button>
          </div>
        </Space>
      ) : (
        <>
          <Flex justify="space-between" gap={10} wrap>
            <Space wrap>
              <Input.Search
                placeholder="Search..."
                allowClear
                onSearch={setSearchText}
                onChange={(e) => setSearchText(e.target.value)}
                style={{ width: "15em" }}
                variant="outlined"
              />
              <CustomSelect
                options={crops}
                value={formData?.crop_id || crops[0].id}
                onChange={(value: any) => {
                  setFormData((prev) => ({ ...prev, crop_id: value }));
                  setSelectedCropsIndex(value);
                }}
                returnId
              />
              <CustomSelect
                options={branches}
                value={formData?.branch_id || branches[0]?.id}
                onChange={(value, _) => {
                  setFormData((prev) => ({ ...prev, branch_id: value }));
                  setSelectedBranchIndex(value);
                  // getAuction(value);
                }}
                returnId
              />
              <CustomSelect
                options={varieties}
                value={formData?.variety_id || varieties[0]?.id}
                onChange={(value, _) => {
                  setFormData((prev) => ({ ...prev, variety_id: value }));
                  getAuction(formData.branch_id, value, formData.crop_id);
                }}
                returnId
              />
            </Space>
            <Button
              loading={isLoading}
              type="primary"
              onClick={() => {
                dispatch(setBypassBD(true));
              }}
            >
              <PlusOutlined /> Create Auction
            </Button>
          </Flex>
          <div className="container table">
            <Table
              style={{ minHeight: "50vh" }}
              columns={columns}
              // dataSource={tableData}
              dataSource={filteredData}
              pagination={{ position: ["bottomRight"] }}
              scroll={{ x: "max-content" }}
              loading={bdLoading}
              size="small"
            />
          </div>
        </>
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    setSelectedBranchIndex: (index: number) =>
      dispatch(setSelectedBranch(index)),
    setSelectedCropsIndex: (index: number) => dispatch(setSelectedCrop(index)),
  };
};
const mapStateToProps = createStructuredSelector({
  branches: selectBranches,
  varieties: selectVarieties,
  selectedCrop: selectSelectedCrop,
  crops: selectCrops,
  TCHtmlString: selectTC,
  userData: selectUserData,
  currentPage: selectCurrentPage,
  selectedBranch: selectSelectedBranch,
  viewAuctionPage: selectViewAuctionPage,
  minQty: selectMinQty,
  saudhaType: selectSaudhaType,
  selectDefaultParams: selectDefaultParams,
  rebates: selectRebates,
  bypassEnabled: selectBypassBD,
  bagTypeList: selectBagtypeList,
});

export default connect(mapStateToProps, mapDispatchToProps)(CopyAuction);
